import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetMemberQueryVariables = Types.Exact<{
  clientUuid: Types.Scalars["String"]["input"];
  userUuid?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetMemberQuery = {
  __typename?: "Query";
  getProfile: {
    __typename?: "Profile";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  };
};

export type MemberFragment = {
  __typename?: "Profile";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
};

export type GetUserAppointmentHistoryQueryVariables = Types.Exact<{
  userUuid: Types.Scalars["String"]["input"];
}>;

export type GetUserAppointmentHistoryQuery = {
  __typename?: "Query";
  getUserAppointmentHistory: Array<{
    __typename?: "AppointmentHistory";
    uuid: string;
    startTime: string;
    endTime: string;
    eventStatus: Types.ScheduleStatus;
    isLateCancel: boolean | null;
    unpaidReason: string | null;
    staff: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
    } | null;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      color: string;
      duration: number;
    };
    appointmentCredit: {
      __typename?: "AppointmentCredit";
      uuid: string;
    } | null;
  }>;
};

export type HistoryFragment = {
  __typename?: "AppointmentHistory";
  uuid: string;
  startTime: string;
  endTime: string;
  eventStatus: Types.ScheduleStatus;
  isLateCancel: boolean | null;
  unpaidReason: string | null;
  staff: {
    __typename?: "User";
    uuid: string;
    firstName: string;
    lastName: string;
  } | null;
  appointmentType: {
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
    duration: number;
  };
  appointmentCredit: { __typename?: "AppointmentCredit"; uuid: string } | null;
};

export type GetUserAppointmentCreditHistoryQueryVariables = Types.Exact<{
  userUuid: Types.Scalars["String"]["input"];
}>;

export type GetUserAppointmentCreditHistoryQuery = {
  __typename?: "Query";
  getUserAppointmentCreditHistory: Array<{
    __typename?: "AppointmentCreditHistory";
    uuid: string;
    expiresAt: string;
    eventStatus: Types.ScheduleStatus;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      color: string;
    };
  }>;
};

export type CreditFragment = {
  __typename?: "AppointmentCreditHistory";
  uuid: string;
  expiresAt: string;
  eventStatus: Types.ScheduleStatus;
  appointmentType: {
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
  };
};

export const MemberFragmentDoc = gql`
  fragment Member on Profile {
    userUuid
    firstName
    lastName
  }
`;
export const HistoryFragmentDoc = gql`
  fragment History on AppointmentHistory {
    uuid
    startTime
    endTime
    eventStatus
    isLateCancel
    unpaidReason
    staff {
      uuid
      firstName
      lastName
    }
    appointmentType {
      uuid
      name
      color
      duration
    }
    appointmentCredit {
      uuid
    }
  }
`;
export const CreditFragmentDoc = gql`
  fragment Credit on AppointmentCreditHistory {
    uuid
    expiresAt
    eventStatus
    appointmentType {
      uuid
      name
      color
    }
  }
`;
export const GetMemberDocument = gql`
  query GetMember($clientUuid: String!, $userUuid: String) {
    getProfile(
      getProfileInput: { clientUuid: $clientUuid, userUuid: $userUuid }
    ) {
      ...Member
    }
  }
  ${MemberFragmentDoc}
`;

/**
 * __useGetMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberQuery({
 *   variables: {
 *      clientUuid: // value for 'clientUuid'
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetMemberQuery(
  baseOptions: Apollo.QueryHookOptions<GetMemberQuery, GetMemberQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMemberQuery, GetMemberQueryVariables>(
    GetMemberDocument,
    options,
  );
}
export function useGetMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMemberQuery,
    GetMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMemberQuery, GetMemberQueryVariables>(
    GetMemberDocument,
    options,
  );
}
export type GetMemberQueryHookResult = ReturnType<typeof useGetMemberQuery>;
export type GetMemberLazyQueryHookResult = ReturnType<
  typeof useGetMemberLazyQuery
>;
export type GetMemberQueryResult = Apollo.QueryResult<
  GetMemberQuery,
  GetMemberQueryVariables
>;
export const GetUserAppointmentHistoryDocument = gql`
  query getUserAppointmentHistory($userUuid: String!) {
    getUserAppointmentHistory(
      getUserAppointmentHistoryInput: { userUuid: $userUuid }
    ) {
      ...History
    }
  }
  ${HistoryFragmentDoc}
`;

/**
 * __useGetUserAppointmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetUserAppointmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAppointmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAppointmentHistoryQuery({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetUserAppointmentHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserAppointmentHistoryQuery,
    GetUserAppointmentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserAppointmentHistoryQuery,
    GetUserAppointmentHistoryQueryVariables
  >(GetUserAppointmentHistoryDocument, options);
}
export function useGetUserAppointmentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAppointmentHistoryQuery,
    GetUserAppointmentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserAppointmentHistoryQuery,
    GetUserAppointmentHistoryQueryVariables
  >(GetUserAppointmentHistoryDocument, options);
}
export type GetUserAppointmentHistoryQueryHookResult = ReturnType<
  typeof useGetUserAppointmentHistoryQuery
>;
export type GetUserAppointmentHistoryLazyQueryHookResult = ReturnType<
  typeof useGetUserAppointmentHistoryLazyQuery
>;
export type GetUserAppointmentHistoryQueryResult = Apollo.QueryResult<
  GetUserAppointmentHistoryQuery,
  GetUserAppointmentHistoryQueryVariables
>;
export const GetUserAppointmentCreditHistoryDocument = gql`
  query getUserAppointmentCreditHistory($userUuid: String!) {
    getUserAppointmentCreditHistory(
      getUserAppointmentCreditHistoryInput: { userUuid: $userUuid }
    ) {
      ...Credit
    }
  }
  ${CreditFragmentDoc}
`;

/**
 * __useGetUserAppointmentCreditHistoryQuery__
 *
 * To run a query within a React component, call `useGetUserAppointmentCreditHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAppointmentCreditHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAppointmentCreditHistoryQuery({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetUserAppointmentCreditHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserAppointmentCreditHistoryQuery,
    GetUserAppointmentCreditHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserAppointmentCreditHistoryQuery,
    GetUserAppointmentCreditHistoryQueryVariables
  >(GetUserAppointmentCreditHistoryDocument, options);
}
export function useGetUserAppointmentCreditHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAppointmentCreditHistoryQuery,
    GetUserAppointmentCreditHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserAppointmentCreditHistoryQuery,
    GetUserAppointmentCreditHistoryQueryVariables
  >(GetUserAppointmentCreditHistoryDocument, options);
}
export type GetUserAppointmentCreditHistoryQueryHookResult = ReturnType<
  typeof useGetUserAppointmentCreditHistoryQuery
>;
export type GetUserAppointmentCreditHistoryLazyQueryHookResult = ReturnType<
  typeof useGetUserAppointmentCreditHistoryLazyQuery
>;
export type GetUserAppointmentCreditHistoryQueryResult = Apollo.QueryResult<
  GetUserAppointmentCreditHistoryQuery,
  GetUserAppointmentCreditHistoryQueryVariables
>;
